const statusActionModalFilter = {
  progress: 'In progress',
  overdue: 'Overdue',
  completed: 'Done',
  canceled: 'Canceled'
};

export default statusActionModalFilter;
